import Cookies from 'js-cookie';
import location from 'services/router/location';
import cookies from 'utils/cookies';

import ServiceBase from '../service-base';

interface PsidService {
  value: string | null;
}

/**
 * Service to handle PSID (Partner Source ID) parameter from URL
 * and persist it to cookies for tracking purposes
 */
class Psid extends ServiceBase<PsidService> {
  name = 'psid';

  // Cookie lifetime in days
  private readonly cookieLifetime = 14;

  constructor() {
    super({ initialState: { value: null } });
  }

  /**
   * Read PSID from URL search parameters
   */
  private readUrlSearchParams(): string | null {
    const searchParams = location.searchParams(true);
    const psidValue = searchParams.psid;

    if (psidValue) {
      // Store in cookie for future use
      Cookies.set('psid', String(psidValue), { expires: cookies.getExpirationDate(this.cookieLifetime) });

      return String(psidValue);
    }

    return null;
  }

  /**
   * Read PSID from cookie
   */
  private readCookie(): string | null {
    const cookieValue = Cookies.get('psid');

    return cookieValue || null;
  }

  /**
   * Get current PSID value
   */
  get current(): string | null {
    return this.data.value;
  }

  /**
   * Initialize the service by checking URL parameters and cookies
   */
  public init(): void {
    const psidFromUrl = this.readUrlSearchParams();
    const psidFromCookie = this.readCookie();

    // Prioritize URL parameter over cookie
    const psidValue = psidFromUrl || psidFromCookie;

    if (psidValue) {
      this.set({ value: psidValue });
    }
  }
}

export default new Psid();
